import BaseRequest from './BaseRequest';

export default class GameMarketplaceRequest extends BaseRequest {
  getList(params) {
    const url = `/public/market-item/search`;
    return this.post(url, params);
  }
  getListBundle(nftContract, params) {
    const url = `/public/market-bundle/${nftContract}`;
    return this.get(url, params);
  }
  getStatistics(nftContract, params) {
    const url = `/public/market-item/${nftContract}/statistics`;
    return this.get(url, params);
  }
  getNFT(nftContract, nftId) {
    const url = `/public/market-item/${nftContract}/${nftId}`;
    return this.get(url, {});
  }
  getBundle(nftContract, packId) {
    const url = `/public/market-bundle/${nftContract}/${packId}`;
    return this.get(url, {});
  }
  getItemTradingEvent(nftContract, nftId, params) {
    const url = `/public/items-trading-event/${nftContract}/${nftId}`;
    return this.get(url, params);
  }
  getBundleTradingEvent(nftContract, nftId, params) {
    const url = `/public/bundle-trading-event/${nftContract}/${nftId}`;
    return this.get(url, params);
  }
  getItemSameCollection(nftContract, nftId) {
    const url = `/public/market-item/${nftContract}/${nftId}/items-same-collection`;
    return this.get(url, {});
  }
  getHallOfFame() {
    const url = '/public/market-general/hall-of-fame';
    return this.get(url, {});
  }
  getFeaturingFromMarketplace(nftContract) {
    const url = `/public/market-item/${nftContract}/featuring-from-marketplace`;
    return this.get(url, {});
  }
  getOffers(nftContract, nftId, params) {
    const url = `/public/offers/${nftContract}/${nftId}`;
    return this.get(url, params);
  }
  getGenres(nftContract) {
    const url = `/public/genres/${nftContract}/filter-tags`;
    return this.get(url, {});
  }
}
